module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.statementRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "subheading hidden-xs-only"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('title')) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.statementRequest.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": "",
      "height": 2
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "pb-0"
  }, [_vm._l((_vm.statements), function(statement) {
    return [_c('statement-list-item', {
      key: statement.id,
      attrs: {
        "value": statement
      },
      on: {
        "send": _vm.initSend,
        "deleted": _vm.get
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-stat-" + (statement.id))
    })]
  }), _vm._v(" "), (!_vm.statementRequest.loading && _vm.statements.length === 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('nostatements.title')) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('nostatements.content')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showSendDialog),
      callback: function($$v) {
        _vm.showSendDialog = $$v
      },
      expression: "showSendDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.$t('dialogs.titles.send')) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showSendDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectedStatement) ? _c('send-statement', {
    attrs: {
      "touch": _vm.sendTouch
    },
    on: {
      "close": function($event) {
        _vm.showSendDialog = false
      }
    },
    model: {
      value: (_vm.selectedStatement),
      callback: function($$v) {
        _vm.selectedStatement = $$v
      },
      expression: "selectedStatement"
    }
  }) : _vm._e()], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579d8a44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/StatementList.vue
// module id = 1431
// module chunks = 9